import React from 'react';
import { Dispatch } from 'redux';
import { connect } from "react-redux";
import { IApplicationState, RootActionCreators } from '../../../store';
import { useTranslation } from 'react-i18next';
import { INavigations, mapNavigationsToProps, AutomaticTaskNavigation, AutomaticTaskNavigationPage } from '../../organisms/automatictask/AutomaticTaskNavigation';
import { IData as IAutomaticTaskData, defaultAutomaticTaskItem as EmptyAutomaticTaskItem } from "../../../store/automatictask/automaticTaskItem";
import { PageHeader } from '../../organisms/PageHeader';
import { AutomaticTaskEdit } from '../../organisms/automatictask/AutomaticTaskEdit';
import { FetchState } from '../../../entities/FetchState';
import { IReportDataObject } from '../../../entities/reports/IReportData';
import ErrorMessage from '../../organisms/ErrorMessage';
import { SavingMessage } from '../../organisms/SavingMessage';
import { SaveButton } from '../../atoms/buttons/SaveButton';

// Standard Properties from parent component
interface IProps { }

// Outgoing functions to parent component
interface IDispatch {}

// Properties from State 
interface IStateProps {
    updateItemState: IReportDataObject<IAutomaticTaskData>
}
const mapStateProps = (state: IApplicationState): IStateProps => ({
    updateItemState: state.automatictask.automatictaskItem.UpdateItem
});

// Outgoing functions to Dispatch
interface IDispatchProps {
    navigations: INavigations;
    onSave: (details: IAutomaticTaskData) => void;
}
const mapDispatchProps = (dispatch: Dispatch): IDispatchProps => ({
    navigations: mapNavigationsToProps(dispatch),
    onSave: (details: IAutomaticTaskData) => dispatch(RootActionCreators.Automatictask.automatictaskItem.UpdateData(
        details.streamId, 
        details.title, 
        details.description, 
        details.completionPeriod, 
        details.forAdmin, 
        details.mandatory, 
        details.fileStatusId
    ))
});

// Actual Component
export type AllProps = IProps & IDispatch & IStateProps & IDispatchProps;
export const AutomaticTaskNewPage = (props: AllProps) => {
    const { t: tAutomaticTask } = useTranslation('automatictask');
    const { t: tCommon } = useTranslation('common');

    // Create a new automatic task item with random UUID
    const [details, setDetails] = React.useState<IAutomaticTaskData>({
        ...EmptyAutomaticTaskItem, 
        streamId: crypto.randomUUID()
    });
    const [isValid, setIsValid] = React.useState(false);

    return (
        <AutomaticTaskNavigation navigations={props.navigations} selected={AutomaticTaskNavigationPage.New}>
            <PageHeader 
                title={tAutomaticTask('title')} 
                subTitle={tAutomaticTask('newTitle')} 
                explainText={tAutomaticTask('newExplanation')} 
            />
            
            <AutomaticTaskEdit
                data={details}
                onUpdate={(data, isValid) => {setDetails(data); setIsValid(isValid); }}
                loading={false}
                prevalidate={true}
                actions={
                    <SaveButton 
                        disabled={!isValid} 
                        onClick={() => props.onSave(details)} 
                    />
                }
            />

            {props.updateItemState.state === FetchState.Busy && 
                <SavingMessage entity={tAutomaticTask('automaticTask')} />
            }
            
            {props.updateItemState.state === FetchState.Error && 
                <ErrorMessage 
                    title={tCommon('savingErrorTitle')} 
                    message={tCommon('savingErrorXMessage', {x: props.updateItemState.errorMessage})} 
                    canClose 
                    options={[]} 
                    errorDetails={JSON.stringify(details)} 
                />
            }
        </AutomaticTaskNavigation>
    );
};

// Connected component for actual use in the app
export default connect<IStateProps, IDispatchProps, {}, IApplicationState>(mapStateProps, mapDispatchProps)(AutomaticTaskNewPage);
